/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/QuizMeCompletion.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { useEffect } from 'react';
import FormattedFraction from 'I18n/components/FormattedFraction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuizMeCompletion = ({
  additionalTracking,
  correctAnswers,
  difficultyLevel,
  handleRestartQuiz,
  totalQuestions
}) => {
  useEffect(() => {
    UsageTracker.trackStandalone('Content Progress', Object.assign({}, additionalTracking, {
      action: 'ai-quiz-me-completed',
      level: difficultyLevel
    }));
  }, [additionalTracking, difficultyLevel]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    blockSize: "100%",
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "center",
    marginInline: "auto",
    children: [/*#__PURE__*/_jsx(Pictogram, {
      name: "CelebrationSuccess"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      marginBlock: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.interactiveEducation.quiz.completed"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlock: "300",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.interactiveEducation.quiz.score",
        options: {
          score: /*#__PURE__*/_jsx(FormattedFraction, {
            denominator: totalQuestions,
            numerator: correctAnswers
          })
        }
      })
    }), /*#__PURE__*/_jsx(Button, {
      marginBlockStart: "200",
      onClick: handleRestartQuiz,
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.interactiveEducation.quiz.retakeQuiz"
      })
    })]
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/QuizMeCompletion.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default QuizMeCompletion;